import logo from 'assets/images/badminton-smash-logo.svg';
import styled from "styled-components";
import { Button } from "shared/Button";
import { ButtonBlue } from "shared/ButtonBlue";
import { TextInput } from "shared/TextInput";
import { BottomNavigation } from 'shared/BottomNavigation';
import { useState } from 'react';
import { ChooseGender } from 'shared/ChooseGender';
import { activatePlayer, getPlayerByActivationCode, IPlayer } from 'api/PlayerApi';
import { useNavigate } from 'react-router-dom';

enum OnboardingStep {
    TypeYourCode,
    EditPlayer,
    SendMeACode
}

export const NewPlayer = () => {
    const navigate = useNavigate();
    const [player, setPlayer] = useState<IPlayer>({} as IPlayer);
    const [formState, setFormState] = useState({
        codeInput: "",
        userMessage: "",
        onboardingStep: OnboardingStep.TypeYourCode
    });

    const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormState(formState => {
            return {...formState, [e.target.name]: e.target.value, userMessage: ""};
        });
    };

    const handlePlayerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPlayer(player => {
            return {...player, [e.target.name]: e.target.value}  as IPlayer;
        });
    };

    const handleGenderChange = (value: boolean) => {
        // console.log("handleGenderChange: ", value);
        setPlayer(player => {
            return {...player, female: value} as IPlayer;
        });
    };

    const validateCode = async () => {

        // console.log("Checking code", formState.codeInput);
        
        const player = await getPlayerByActivationCode(formState.codeInput);
        setPlayer(player);

        // console.log("Found player", player);
        // console.log(player?.activationCode === formState.codeInput);

        if(player?.activationCode === formState.codeInput) {
            
            setFormState(formState => {
                return {...formState, 
                    onboardingStep: OnboardingStep.EditPlayer
                };
            });

        } else {
            
            setFormState(formState => {
                return {...formState, userMessage: "Koden er ugyldig. Prøv igen."};
            });
        }
    }

    const handleActivatePlayer = async () => {
        // console.log("The user entered his/her player info: ", player);
        activatePlayer(player);
        navigate("/match");
    }

    const handleIDontHaveACode = async () => {
        setFormState(formState => {
            return {...formState, 
                onboardingStep: OnboardingStep.SendMeACode
            };
        });
    }

    const handleSendMeACode = async () => {
        console.log("Send a code to the user");
    }

    const typeYourCodeHtml = () => {
        return (
            <>
                <TextInput
                    name="codeInput"
                    value={formState.codeInput}
                    placeholderText='Indtast din kode'
                    onChange={handleFormChange} />
                <Button text="OK" onClick={validateCode} />
                <br /><br /><br />
                <ButtonBlue text="Jeg har ikke en kode" onClick={handleIDontHaveACode} />
            </>
        )
    }

    const editPlayerHtml = () => {
        return (
            <>
                <TextInput
                    name="name"
                    value={player?.name ?? ""}
                    placeholderText='Indtast dit navn'
                    onChange={handlePlayerChange} />
                <ChooseGender 
                    female={player?.female ?? true}
                    onClick={handleGenderChange} />
                <Button 
                    text="OK"
                    onClick={handleActivatePlayer} />
            </>
        )
    }

    const sendMeACodeHtml = () => {
        return (
            <>
                <TextInput
                    name="email"
                    value={player?.email ?? ""}
                    placeholderText='Indtast din e-mail'
                    onChange={handlePlayerChange} />
                <Button text="OK" onClick={handleSendMeACode} />
            </>
        )
    }

    return (
        <div>
            <img src={logo} alt="Badminton Smash logo" />
            <UserMessage>{formState.userMessage}</UserMessage>

            {(() => {
                    switch (formState.onboardingStep) {
                    case OnboardingStep.TypeYourCode:
                        return typeYourCodeHtml();

                    case OnboardingStep.EditPlayer:
                        return editPlayerHtml();

                    case OnboardingStep.SendMeACode:
                        return sendMeACodeHtml();

                    default:
                        return null
                    }
            })()}

            <BottomNavigation />
        </div>
    )
}

const UserMessage = styled.div`
    color: white;
    font-size: 22px;
    height: 40px;
`;